import formatters from 'lib/formatters'
import SectionHeader from '../../../Distributions/components/Header/SectionHeader.js'
import styles from './styles.css'
import { getDepositTypeLabel, safeGet, normalizeAccountName } from './utils.js'

export default function DepositView(props) {
  const { form = {}, setEdit } = props

  return (
    <div style={{ width: '930px', marginBottom: '18px' }}>
      <div className={styles.depositCard}>
        <SectionHeader
          title={'Deposit Review'}
          extra={
            <div className={styles.editButton} onClick={() => setEdit?.(true)}>
              Edit
            </div>
          }
        />

        <div className={styles.depositCardWrapper}>
          <div className={styles.depositMainGrid}>
            <div className={styles.depositTypeColumn}>
              <div className={styles.depositTypeLabel}>{getDepositTypeLabel(form.deposit_type)}</div>

              <div className={styles.infoItem}>
                <div className={styles.infoLabel}>Deposit Date</div>
                <div className={styles.infoValue}>{form.bank_date ? formatters.date(form.bank_date) : 'Not specified'}</div>
              </div>

              <div className={styles.infoItem}>
                <div className={styles.infoLabel}>Amount</div>
                <div className={styles.infoValue}>{form.amount ? formatters.money(form.amount) : '$0.00'}</div>
              </div>
            </div>

            <div className={styles.accountColumn}>
              {!form.deposit_to_cash && form.trust_account && (
                <div className={styles.infoItem}>
                  <div className={styles.infoLabel}>Client Account</div>
                  <div className={styles.infoValue}>{safeGet(form, 'trust_account.number', 'Not specified')}</div>
                </div>
              )}

              {form.deposit_to_cash && (
                <div className={styles.infoItem}>
                  <div className={styles.infoLabel}>Cash Account</div>
                  <div className={styles.infoValue}>{form.cash_account || 'Not specified'}</div>
                </div>
              )}

              {form.deposit_type === 'check' ? (
                <div className={styles.infoItem}>
                  <div className={styles.infoLabel}>Bank Account Received</div>
                  <div className={styles.infoValue}>{form.receiving_bank_account || 'No account found'}</div>
                </div>
              ) : (
                <div className={styles.infoItem}>
                  <div className={styles.infoLabel}>Bank Account Received</div>
                  <div className={styles.infoValue}>
                    {(form.deposited_bank_account && form.deposited_bank_account.replace(/_/g, ' ')) || 'No account found'}
                  </div>
                </div>
              )}
              {(form.deposit_type === 'wire' || form.deposit_type === 'direct_deposit') &&
                form.deposited_bank_account &&
                form.receiving_bank_account &&
                normalizeAccountName(form.deposited_bank_account) !== normalizeAccountName(form.receiving_bank_account) && (
                  <div className={styles.infoItem}>
                    <div className={styles.orange}>Transferred to Bank Account</div>
                    <div className={styles.infoValue}>{form.receiving_bank_account}</div>
                  </div>
                )}
            </div>

            <div className={styles.feeColumn}>
              <div className={styles.depositTypeLabel}>APPLIED FEE</div>

              <div className={styles.feeBalanceInfo}>
                <div className={styles.feeBalanceLabel}>Balance Used for Fee Calculation</div>
                <div className={styles.feeBalanceValue}>{formatters.money(form.total_balance_snapshot ?? 0)}</div>
              </div>

              <div className={styles.feeGrid}>
                <div className={styles.feeGridItem}>
                  <div className={styles.feeGridLabel}>Rate</div>
                  <div className={styles.feeGridValue}>{form.fee_rate ? `${form.fee_rate}%` : '0.00%'}</div>
                </div>

                <div className={styles.feeGridItem}>
                  <div className={styles.feeGridLabel}>Admin Fee</div>
                  <div className={styles.feeGridValue}>{formatters.money(form.fee_amount ?? 0)}</div>
                </div>

                <div className={styles.feeGridItem}>
                  <div className={styles.feeGridLabel}>Enroll Fee</div>
                  <div className={styles.feeGridValue}>{formatters.money(form.enrollment_fee_amount ?? 0)}</div>
                </div>
              </div>

              {form.beneficiary_over_65 && form.on_ssi && <div className={styles.specialNotice}>Beneficiary is over 65 and on SSI.</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
